export default __webpack_public_path__ + "static/media/Export-Done-Icon@2x.c2b390ea.png";